<template>
  <div id="app">
    <v-app id="inspire">
      <v-app id="inspire">
        <v-main>
          <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
              <v-col cols="6">
                <v-card class="elevation-0 login-formMainDiv" :loading="loading">
                  <v-card-title class="text-h4 font-weight-bold my-3">Reset Password</v-card-title>
                  <!-- <v-toolbar color="primary" dark flat>
                    <v-toolbar-title>Reset Password</v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar> -->
                  <v-card-text class="pb-0">
                    <v-form>
                      <v-text-field label="password" name="password"
                        :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showNewPassword ? 'text' : 'password'" @click:append="showNewPassword = !showNewPassword"
                        outlined dense v-model="form.password" :error="errors.password != null"
                        :error-messages="errors.password"></v-text-field>
                      <v-text-field label="Confirm Password" name="password_confirmation"
                        :type="showConfirmPassword ? 'text' : 'password'"
                        :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showConfirmPassword = !showConfirmPassword" outlined dense
                        v-model="form.password_confirmation" :error="errors.password_confirmation != null"
                        :error-messages="errors.password_confirmation"></v-text-field>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="px-4">
                    <v-btn :loading="loading" block color="black" class="white--text" :disabled="loading"
                      @click="onSubmit">Submit</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="6" class="loginBgImg">
                <!-- <img src="../../assets/Group.svg" width="100%" /> -->
              </v-col>
            </v-row>
          </v-container>
        </v-main>
      </v-app>
    </v-app>
    <v-snackbar v-model="snackbar" :timeout="3000" color="info" align-baseline="center">
      {{ message }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      loading: false,
      form: {
        password: "",
        password_confirmation: "",
      },
      errors: {},
      message: "",
      snackbar: false,
      token: null,
      showNewPassword: false,
      showConfirmPassword: false,
    };
  },
  methods: {
    onSubmit(event) {
      let _self = this;
      event.preventDefault();

      _self.loading = true;

      this.$axios
        .post('admin/resetPassword/' + _self.token, _self.form)
        .then((res) => {
          let responsedata = res.data
          _self.loading = false

          if (!responsedata.success) {
            _self.errors = {};
            if (responsedata.errors) {
              for (let i = 0; i < responsedata.errors.length; i++) {
                _self.errors[responsedata.errors[i].field] =
                  responsedata.errors[i].message;
              }
            }
          }
          else {
            localStorage.removeItem('user')
            _self.$router.push('/login')
          }

          _self.snackbar = true
          _self.message = responsedata.message
        })
    },
  },
  mounted() {
    this.$route.params.token ? this.token = this.$route.params.token : this.token = JSON.parse(localStorage.getItem('user')).token
  }
};
</script>

<style>
.loginBgImg {
  background-image: url('../../assets/login-v1.svg');
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100vh;
}

.login-formMainDiv {
  width: min(100%, 400px);
  margin-inline: auto;
}
</style>
